import React, { forwardRef } from 'react';
import { Container, Grid } from '@printdeal/ui-library';
import cx from 'clsx';
import Sidebar from '../Sidebar';
import ErrorBoundary from '../error-handling/ErrorBoundary';

interface Props {
  children: React.ReactNode | React.ReactNode[];
  withSidebar?: boolean;
  className?: string;
  containerClassName?: string;
  isFullWidth?: boolean;
  withDivider?: boolean;
  backgroundColor?: string;
}

const LayoutSection = forwardRef<HTMLDivElement, Props>(({
  children,
  withSidebar = true,
  className = '',
  containerClassName,
  isFullWidth = true,
  withDivider = true,
  backgroundColor = 'pd-bg-white',
}, ref) => (
  <div
    className={cx(backgroundColor, className, 'pd-py-12')}
    ref={ref}
  >
    {isFullWidth ? (
      <Container className={cx('pd-relative pd-z-10', containerClassName)}>
        {withSidebar ? (
          <Grid className="pd-grid-cols-12 pd-gap-6">
            <Grid.Item className="pd-col-span-12 md:pd-col-span-8 lg:pd-col-span-9">
              <ErrorBoundary inline>
                {children}
              </ErrorBoundary>
            </Grid.Item>
            <Grid.Item className="pd-col-span-12 md:pd-col-span-4 lg:pd-col-span-3">
              <Sidebar />
            </Grid.Item>
          </Grid>
        ) : (
          <ErrorBoundary inline>
            {children}
          </ErrorBoundary>
        )}
      </Container>
    ) : (
      <Container className={cx('pd-relative pd-z-10', containerClassName)}>
        <Grid className="pd-grid-cols-12 pd-gap-6">
          <Grid.Item className="pd-col-span-12 lg:pd-col-span-8 lg:pd-col-start-3">
            <ErrorBoundary inline>
              {children}
            </ErrorBoundary>
          </Grid.Item>
        </Grid>
      </Container>
    )}

    {withDivider && (
      <div className="pd-bg-light">
        <Container className={containerClassName}>
          <hr className="pd-my-0" />
        </Container>
      </div>
    )}
  </div>
));

export default LayoutSection;
